
<div *ngIf="isModalOpen" class="modal">
  <!-- add the select attribute to ng-content -->
  <div class="modal-content" (clickOutside)="onClickedOutside($event)">
    <div (click)="closeModal()" class="close-modal-button"><mat-icon>close</mat-icon></div>
    <ng-content select="[slot=modal-content]" class="modal-content"></ng-content>
  </div>
</div>
